import { CircularProgress } from "@mui/joy";
import {
  CancelIcon,
  CheckCircleIcon,
  PendingIcon,
  SHourglass,
  SSend,
  UnsubscribeIcon,
  WarningAmberRoundedIcon,
} from "styles/StyledMUI";
import { smsStatusMeta } from "./smsStatusMeta";

export default function SmsStatusIcon({ status }: { status: string }) {
  const sx = { fontSize: 22, flexShrink: 0, color: smsStatusMeta(status).color };

  switch (status) {
    case "sending":
      return (
        <CircularProgress size="sm" sx={{ "--CircularProgress-size": "22px", flexShrink: 0 }} />
      );
    case "pending":
      return <PendingIcon sx={sx} />;
    case "accepted":
    case "moderated":
      return <SHourglass sx={sx} />;
    case "sent":
      return <SSend sx={sx} />;
    case "delivered":
      return <CheckCircleIcon sx={sx} />;
    case "blacklisted":
      return <UnsubscribeIcon sx={sx} />;
    case "failed":
    case "cancelled":
    case "not_sent":
    case "denied":
    case "undelivered":
      return <CancelIcon sx={sx} />;
    default:
      return <WarningAmberRoundedIcon sx={sx} />;
  }
}
